/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { CombinedVisitorAdapter } from '../../combined/visitors/CombinedVisitorAdapter';
import { OasPathItem } from '../../openapi/models/OasPathItem';

/**
 * Finds the first path item.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends CombinedVisitorAdapter
 */
export class PathItemFinder extends CombinedVisitorAdapter {
    public found : OasPathItem;

    /**
     * @see io.apicurio.datamodels.openapi.visitors.OasVisitorAdapter#visitPathItem(io.apicurio.datamodels.openapi.models.OasPathItem)
     * @param {OasPathItem} node
     */
    public visitPathItem(node : OasPathItem) {
        if(this.found == null) {
            this.found = node;
        }
    }

    /**
     * Returns true if an operation was found.
     * @return {boolean}
     */
    public isFound() : boolean {
        return this.found != null;
    }

    constructor() {
        super();
        if(this.found===undefined) this.found = null;
    }
}
PathItemFinder["__class"] = "io.apicurio.datamodels.core.visitors.PathItemFinder";
PathItemFinder["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




